/**
 * @flow
 * @format
 */

import React from 'react';
import { connect } from 'react-redux';
import { compose, pure } from 'recompose';
import { Row, Col, Card } from 'reactstrap';

import { getErrors } from '~/selectors/errors';
import type { StateType, ErrorType } from '~/actions/errors';

import classes from './ErrorComponent.scss';

type PropsType = {
  errors: Array<ErrorType>,
};

// eslint-disable-next-line react/prefer-stateless-function
export class ErrorComponent extends React.Component<PropsType, *> {
  static defaultProps = {
    errors: [],
  };
  props: PropsType;

  render() {
    const errors: any = this.props.errors.map((e: ErrorType) => (
      <div key={e.data.timestamp}>{e.data.message}</div>
    ));
    return (
      <Row className={classes.wrapper}>
        <Col className="pt-3">
          <Card body className="bg-danger">
            <div className={classes.errorWrapper}>
              <span>Error: {errors}</span>
            </div>
          </Card>
        </Col>
      </Row>
    );
  }
}

function mapStateToProps(state: StateType): PropsType {
  return {
    errors: getErrors(state),
  };
}

const enhancer = compose(connect(mapStateToProps), pure);

export default enhancer(ErrorComponent);



// WEBPACK FOOTER //
// ./src/components/ErrorComponent/ErrorComponent.js